// @flow
import SubMenuHeader from 'components/header/SubMenuHeader';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/header/SubMenuHeader';
import { withRouter } from 'react-router-dom';
export default withRouter(
  connect(
    (state: StateType): StateProps => ({
      subMenus: state.pageNodeState.pageNode.liste_enfants,
      status: state.pageNodeState.status
    })
  )(SubMenuHeader)
);
